import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static";
import TextArea from "../../../ui/molecules/textArea";
import { OptionType } from "../../../utils";
import { isNonComplianceMapping, nonComplianceMap, nonComplianceOptions } from "../../../utils/measuresUtils";
import { setForeseenAccessoryMeasure, setNewMeasureUpdateLegislativeReferenceText } from "../measures/slice";
import { NonComplianceMapping } from "../measuresOtherOdc/dataService/dto";
import { AllAreasDTO } from "./dto";
import { GetAllAreas, GetAllncByArea, resetGetAllStatus, resetGetByAreaStatus } from "./slice";

interface Props {
    type: 'old' | 'new' | undefined
    formType?: 'add' | 'edit' | undefined
    onChange?: (value: string | undefined) => void
    newDefaultValue?: {
        areaCode: string
        areaDescription: string
        ncId: string
        ncDescription: string
        legReference: string
    }
    oldDefaultValue?: {
        code: string
        legislativeReference: string | undefined
    }
    value?: string
    errorLabel?: string
    label?: string
    disabled?: boolean
}

export function NonComplianceCode(props: Props) {
    const [selectedValue, setSelectedValue] = useState<string | undefined>(props.type === 'old' ? props.oldDefaultValue?.code : props.newDefaultValue?.areaCode);

    const NonComplianceCodesState = useAppSelector(state => state.NonComplianceCodes)
    const newMeasureState = useAppSelector(state => state.newMeasure)
    const OtherOdcMeasuresState = useAppSelector(state => state.OtherOdcMeasuresState)

    const [nonComplianceCodes, setNonComplianceCodes] = useState<OptionType[]>([])
    const [areaCodes, setAreaCodes] = useState<OptionType[]>([])
    const [areadescription, setAreaDescription] = useState<string | undefined>('')
    const [ncdescription, setNcDescription] = useState<string | undefined>('')
    const [legislativeReference, setLegislativeReference] = useState<string | undefined>('')
    const [selectedNcInfoOld, setSelectedNcInfoOld] = useState<NonComplianceMapping | null>(null);

    const dispatch = useAppDispatch()

    const extractSingleValue = (value: string | string[] | null | undefined | { value?: string } | { value?: string }[]) => {
        if (typeof value === 'string') {
            return value
        }
        if (Array.isArray(value)) {
            const first = value[0]
            if (typeof first === 'string') {
                return first
            }
            if (first && typeof first === 'object' && 'value' in first && typeof first.value === 'string') {
                return first.value
            }
            return undefined
        }
        if (value && typeof value === 'object' && 'value' in value && typeof value.value === 'string') {
            return value.value
        }
        return undefined
    }

    useEffect(() => {
        if (props.type === 'new') {
            dispatch(GetAllAreas())
        } else {
            setNonComplianceCodes(nonComplianceOptions)
        }
    }, [props.type])

    useEffect(() => {
        if (props.formType === 'edit' && props.type === 'old') {
            if (props.oldDefaultValue) {
                const infoNc = nonComplianceMap.get(props.oldDefaultValue?.code) || null
                if (infoNc && isNonComplianceMapping(infoNc)) {
                    setSelectedNcInfoOld(infoNc)
                    dispatch(setForeseenAccessoryMeasure(infoNc.accessoryMeasures))
                    console.log(infoNc)
                }
            }
        }

        if (props.formType === 'edit' && props.type === 'new') {
            if (props.newDefaultValue) {
                dispatch(GetAllncByArea(props.newDefaultValue.areaCode))
                setAreaDescription(props.newDefaultValue.areaDescription)
                setNcDescription(props.newDefaultValue.ncDescription)
                setLegislativeReference(props.newDefaultValue.legReference)
            }
        }
    }, [])

    useEffect(() => {
        if (
            NonComplianceCodesState.AreasResponseStatus === 'successfully' &&
            NonComplianceCodesState.AreasResponse
        ) {
            const areas = (NonComplianceCodesState.AreasResponse as AllAreasDTO[]).map(area => ({
                value: area.areaCode,
                label: area.areaCode
            }) as OptionType)

            dispatch(resetGetAllStatus())
            setAreaCodes(areas)
        }
    }, [NonComplianceCodesState.AreasResponseStatus])

    useEffect(() => {
        if (NonComplianceCodesState.AreasbyCodeResponseStatus === 'successfully') {
            const dataNc = NonComplianceCodesState.AreasResponseByCode.map(ncCode => {
                setAreaDescription(ncCode.nonComplianceAreaDTO?.areaCode + " - " + ncCode.nonComplianceAreaDTO?.ncDescription)
                return {
                    value: ncCode.id,
                    label: ncCode.nonComplianceCode
                } as OptionType
            })
            setNonComplianceCodes(dataNc)
            dispatch(resetGetByAreaStatus())
        }
    }, [NonComplianceCodesState.AreasbyCodeResponseStatus])
    //popolamento select area
    // useEffect(() => {
    //     console.log('use effect dubbio')
    //     if (NonComplianceCodesState.AreasbyCodeResponseStatus === 'successfully' && NonComplianceCodesState.AreasResponseByCode) {
    //         const dataNc = NonComplianceCodesState.AreasResponseByCode.map(ncCode => {
    //             return {
    //                 value: ncCode.id,
    //                 label: ncCode.nonComplianceCode
    //             } as OptionType
    //         })
    //         dispatch(resetGetByAreaStatus())
    //         setNonComplianceCodes(dataNc)
    //     }
    // }, [NonComplianceCodesState.nonComplianceCodesResponseStatus])

    const handleChangeArea = (value: string | string[] | null | undefined) => {
        const normalizedValue = extractSingleValue(value)
        if (normalizedValue !== undefined) {
            dispatch(GetAllncByArea(normalizedValue))
        }
    };

    const handleChangeNc = (value: string | string[] | null | undefined) => {
        const normalizedValue = extractSingleValue(value)
        setSelectedValue(normalizedValue);
        if (props.type === 'new') {
            const ncSelected = NonComplianceCodesState.AreasResponseByCode.find(el => el.id === normalizedValue);
            setNcDescription(ncSelected?.description)
            setLegislativeReference(ncSelected?.legislativeReference)
            if (props.onChange) {
                props.onChange(normalizedValue);
            }
        }
        else {
            if (normalizedValue) {
                if (props.onChange) {
                    props.onChange(normalizedValue);
                }
                const infoNc = nonComplianceMap.get(normalizedValue) || null
                if (infoNc && isNonComplianceMapping(infoNc)) {
                    setSelectedNcInfoOld(infoNc)
                    dispatch(setForeseenAccessoryMeasure(infoNc.accessoryMeasures))
                }
            }
        }
    };

    if (props.type === 'new') {
        return (
            <div className="flex flex-col gap-5 w-full">
                <div className="flex flex-col gap-3">
                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Non conformita / Area</span>
                    <MadfarmStaticSelect
                        label="Codice Non Conformità"
                        placeholder={'es. AA.01'}
                        value={props.value ?? selectedValue}
                        options={areaCodes}
                        onChange={handleChangeArea}
                        disabled={props.disabled}
                        noOptionsMessage={""}
                    />
                </div>

                <div className="rounded-xl border border-neutral-200 bg-white p-4">
                    <div className="text-xs font-semibold uppercase tracking-wide text-neutral-500">Area</div>
                    <div className="mt-1 text-sm font-medium text-neutral-700">{areadescription || '-'}</div>
                </div>

                <div className="border-t border-neutral-200" />

                <div className="mt-6">
                    <MadfarmStaticSelect
                        label="Codice Riferimento Normativo Non Conformità"
                        placeholder={'Codice NC'}
                        options={nonComplianceCodes}
                        value={props.newDefaultValue?.ncId}
                        onChange={handleChangeNc}
                        disabled={props.disabled}
                        noOptionsMessage={""}
                    />
                </div>

                <div className="rounded-xl border border-neutral-200 bg-white p-4">
                    <div className="text-xs font-semibold uppercase tracking-wide text-neutral-500">Dettaglio</div>
                    <div className="mt-1 text-sm font-medium text-neutral-700">{ncdescription || '-'}</div>
                </div>

                <div className="rounded-xl border border-neutral-200 bg-white p-4">
                    <div className="text-xs font-semibold uppercase tracking-wide text-neutral-500">Riferimento normativo</div>
                    <div className="mt-1 text-sm font-medium text-neutral-700">{legislativeReference || '-'}</div>
                </div>
            </div>
        )
    }

    if (props.type === 'old') {
        return (
            <div className="flex flex-col gap-5 w-full">
                <div className="flex flex-col gap-3">
                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Non conformita / Codice</span>
                    <MadfarmStaticSelect
                        label="Codice NC"
                        placeholder={'Codice NC'}
                        value={props.value ?? selectedValue}
                        //gestire caso nuovo provvedimento ma con codice vecchio
                        error={OtherOdcMeasuresState.otherOdcMeasuserOldErrors.nonComplianceCode}
                        errorLabel='Codice mancante'
                        options={nonComplianceCodes}
                        defaultValue={props.oldDefaultValue?.code}
                        onChange={handleChangeNc}
                        disabled={props.disabled}
                        noOptionsMessage={""}
                    />
                </div>

                <div className="rounded-xl border border-neutral-200 bg-white p-4">
                    <div className="text-xs font-semibold uppercase tracking-wide text-neutral-500">Area controllo</div>
                    <div className="mt-1 text-sm font-medium text-neutral-700">
                        {selectedNcInfoOld ? `${selectedNcInfoOld.areaCode} - ${selectedNcInfoOld.nonComplianceDescription}` : '-'}
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div className="rounded-xl border border-neutral-200 bg-white p-4 text-left">
                        <div className="text-xs font-semibold uppercase tracking-wide text-neutral-500">Tipologia</div>
                        <div className="mt-1 text-sm font-medium text-neutral-700">{selectedNcInfoOld?.nonComplianceType || '-'}</div>
                    </div>
                    <div className="rounded-xl border border-neutral-200 bg-white p-4 text-left">
                        <div className="text-xs font-semibold uppercase tracking-wide text-neutral-500">Misura adottata</div>
                        <div className="mt-1 text-sm font-medium text-neutral-700">{selectedNcInfoOld?.measureTypeDetail || '-'}</div>
                    </div>
                </div>
                <TextArea
                    label="Riferimento normativo"
                    onChangeText={(text) => dispatch(setNewMeasureUpdateLegislativeReferenceText(text))}
                    value={newMeasureState.newMeasureUpdateRequest.legislativeReferenceText || selectedNcInfoOld?.legislativeReference}
                />
            </div>
        )
    }
    return (<></>)
}